import React from 'react';

const NumericInput = ({ value, onChange, maxLength, className = "" }) => {
  const handleChange = (event) => {
    const sanitizedValue = event.target.value.replace(/[^0-9]/g, '');
    onChange(sanitizedValue);
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      maxLength={maxLength}
      className={`form-control p-inputmask p-inputtext p-component ${className}`.trim()}
    />
  );
};

export default NumericInput;
